import { render } from "./Contacto.vue?vue&type=template&id=734474fb&scoped=true"
import script from "./Contacto.vue?vue&type=script&lang=js"
export * from "./Contacto.vue?vue&type=script&lang=js"

import "./Contacto.vue?vue&type=style&index=0&id=734474fb&scoped=true&lang=css"

import exportComponent from "/Users/desarrollo/Documents/Proyectos/friax/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-734474fb"]])

export default __exports__